/**
 * SF35 — Audio Transcript JSON UX Contract
 * ऑडियो ट्रांसक्रिप्ट JSON UX अनुबंध — owner-facing workflow steps
 */
const OWNER_UX_STEPS = Object.freeze([
    Object.freeze({ stepNumber: 1, instruction: 'Audio/video file चुनो', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 2, instruction: 'Domain चुनो: कुंडली / वास्तु / mixed / general', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 3, instruction: 'भाषा hint चुनो: हिंदी / गुजराती / mixed', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 4, instruction: 'Privacy और budget preview देखो', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 5, instruction: 'Transcription dry-run देखो', requiresOwnerAction: false }),
    Object.freeze({ stepNumber: 6, instruction: 'Owner-approved staging transcription चलाओ', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 7, instruction: 'Transcript preview देखो', requiresOwnerAction: false }),
    Object.freeze({ stepNumber: 8, instruction: 'Redaction review करो', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 9, instruction: 'JSON extraction preview देखो', requiresOwnerAction: false }),
    Object.freeze({ stepNumber: 10, instruction: 'Output folder चुनो', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 11, instruction: 'Write approval दो', requiresOwnerAction: true }),
    Object.freeze({ stepNumber: 12, instruction: 'transcript.txt, transcript.segments.json, kundali_vastu_extract.json, audit.json बनें', requiresOwnerAction: false }),
    Object.freeze({ stepNumber: 13, instruction: 'जरूरत पड़े तो rollback करो', requiresOwnerAction: true }),
]);
export const AUDIO_TRANSCRIPT_JSON_UX_CONTRACT_SF35 = Object.freeze({
    version: '0.1.104',
    ownerUxSteps: OWNER_UX_STEPS,
    totalSteps: OWNER_UX_STEPS.length,
    ownerActionSteps: OWNER_UX_STEPS.filter(s => s.requiresOwnerAction).length,
    outputFiles: Object.freeze(['transcript.txt', 'transcript.segments.json', 'kundali_vastu_extract.json', 'audit.json']),
    rollbackAvailable: true,
    providerCallDefaultDisabled: true,
    rawAudioNotStored: true,
    ownerApprovalRequired: true,
});
//# sourceMappingURL=audioTranscriptJsonUxContractSf35.js.map